import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { NotFoundError } from '@cian/peperrors/shared';
import { GlobalEventsLogs } from '../internal/GlobalEventsLogs';
var globalEventsLogsSettings = {
  ttl: 60000
};
export function setupGlobalEventsLogs() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  globalEventsLogsSettings = _objectSpread(_objectSpread({}, globalEventsLogsSettings), settings);
}
export function initGlobalEventsLogs() {
  if (window.__cianGlobalEventsLogs) {
    return window.__cianGlobalEventsLogs;
  }

  window.__cianGlobalEventsLogs = new GlobalEventsLogs(globalEventsLogsSettings.ttl);
  return window.__cianGlobalEventsLogs;
}
export function getGlobalEventsLogs() {
  if (!window.__cianGlobalEventsLogs) {
    throw new NotFoundError({
      message: 'GlobalEventsLogs must be initialized before accessing it. Forgot to call init() before accessing log?',
      domain: '@cian/events-log/interface'
    });
  }

  return window.__cianGlobalEventsLogs;
}